module.exports = __webpack_public_path__ + "img/car-green-vertical.436375be.svg";